export const LOGO_LIGHT = "/assets/Coke/light-theme-logo.svg";
export const LOGO_DARK = "/assets/Coke/dark-theme-logo.svg";
export const EMPTY_STATE = "/assets/States/empty-state.svg";
